import { render, staticRenderFns } from "./subordinate.vue?vue&type=template&id=726cff50&scoped=true&"
import script from "./subordinate.vue?vue&type=script&lang=js&"
export * from "./subordinate.vue?vue&type=script&lang=js&"
import style0 from "./subordinate.vue?vue&type=style&index=0&id=726cff50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726cff50",
  null
  
)

export default component.exports